import { render } from "./ContactComponent.vue?vue&type=template&id=5e94bc22&scoped=true"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=5e94bc22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e94bc22"]])

export default __exports__